import { Box, Button, Checkbox, Flex, HStack, Link } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import config from '@common/config';
import { AgreementCode } from '@services/appsync/types';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UI } from 'src/apps/invest/common/shells/UI';
import { useInboxModel } from '../../../../../common/models/InboxModel';
import { useInvestorAccountModel } from '../../../../../common/models/InvestorAccountModel';
import { TextBlock } from '../../../common/components/TextBlock';
import { ROUTES } from '../../../config';
import { useInboxViewModel } from '../../models/InboxViewModel';
import { AgreementBulletPoint } from '../../types';

const iconSize = {
  desktop: 80,
  mobile: 60,
};

const agreementBulletPoints: AgreementBulletPoint[] = [
  { icon: 'unlock', text: 'Unlock financial goals, enable enhanced auto-investments & new future features.' },
  { icon: 'robot', text: 'Gain new functionality to make managing a real estate portfolio more automated.' },
  { icon: 'chart-line', text: 'You get a more customezed real estate portfolio to support your goals.' },
];

export const Agreement: React.FC = () => {
  ``;
  const [agreementChecked, setAgreementChecked] = useState(false);
  const [processing, setProcessing] = useState(false);

  const navigate = useNavigate();

  const model = useInboxViewModel();
  const investorModel = useInvestorAccountModel();
  const inboxModel = useInboxModel();
  return (
    <UI>
      <Flex flex={1} alignItems="center" flexDirection="column" justifyContent={'center'}>
        <Flex flexDirection={'column'} alignItems={'center'} maxWidth={350}>
          <Box
            w={[iconSize.mobile + 'px', iconSize.desktop + 'px']}
            h={[iconSize.mobile + 'px', iconSize.desktop + 'px']}
            position="relative">
            <Box
              bgColor={'blue.50'}
              w={[iconSize.mobile + 'px', iconSize.desktop + 'px']}
              h={[iconSize.mobile + 'px', iconSize.desktop + 'px']}
              position="absolute"
              borderRadius={[iconSize.mobile, iconSize.desktop]}></Box>
            <Box
              bgColor={['transparent', 'blue.100']}
              opacity={0.5}
              w={[iconSize.mobile - 20 + 'px', iconSize.desktop - 20 + 'px']}
              h={[iconSize.mobile - 20 + 'px', iconSize.desktop - 20 + 'px']}
              position="absolute"
              borderRadius={60}
              top={[
                (iconSize.mobile - (iconSize.mobile - 20)) / 2 + 'px',
                (iconSize.desktop - (iconSize.desktop - 20)) / 2 + 'px',
              ]}
              left={[
                (iconSize.mobile - (iconSize.mobile - 20)) / 2 + 'px',
                (iconSize.desktop - (iconSize.desktop - 20)) / 2 + 'px',
              ]}></Box>
            <Icon
              icon={'file-contract'}
              boxSize={[iconSize.mobile * 0.3 + 'px', iconSize.desktop * 0.3 + 'px']}
              color={'blue.300'}
              top={[
                (iconSize.mobile - iconSize.mobile * 0.3) / 2 + 'px',
                (iconSize.desktop - iconSize.desktop * 0.3) / 2 + 'px',
              ]}
              left={[
                (iconSize.mobile - iconSize.mobile * 0.3) / 2 + 'px',
                (iconSize.desktop - iconSize.desktop * 0.3) / 2 + 'px',
              ]}
              position="absolute"
            />
          </Box>
        </Flex>
        <TextBlock textAlign="center" mt={'20px'} fontSize={'24px'} weight="bold">
          Advisory Agreement
        </TextBlock>
        <Flex flexDirection="column" alignItems="center" justifyContent="center" w={'100%'}>
          {agreementBulletPoints.map((point, i) => {
            return (
              <HStack key={`agreement-point-${i}`} mt={'36px'} w={'100%'} maxW={'520px'} h="42px" alignItems="center">
                <Flex
                  alignItems="center"
                  justifyContent="center"
                  backgroundColor="blue.500"
                  w={'42px'}
                  h={'42px'}
                  borderRadius="30px">
                  <Icon color="white" icon={point.icon} fontSize="18px" />
                </Flex>
                <Flex flex={1}>
                  <TextBlock lineHeight="16px">{point.text}</TextBlock>
                </Flex>
              </HStack>
            );
          })}
        </Flex>
        <Flex mt={'40px'} flexDirection="column" alignItems="center">
          <HStack alignItems={'flex-start'}>
            <Checkbox
              isChecked={agreementChecked}
              onChange={(e) => {
                e.stopPropagation();
                setAgreementChecked(!agreementChecked);
              }}
              mt={'4px'}></Checkbox>
            <TextBlock
              onClick={(e) => {
                e.stopPropagation();

                setAgreementChecked(!agreementChecked);
              }}>
              By checking this box, you agree to{' '}
              <Link
                href={config.PROGRAM_AGREEMENT}
                target={'_blank'}
                onClick={(e) => {
                  e.stopPropagation();
                }}>
                Concreit's Advisory Agreement
              </Link>
            </TextBlock>
          </HStack>
          <Button
            isLoading={processing}
            onClick={async () => {
              setProcessing(true);
              const res = await model.acceptAgreements([AgreementCode.ADVISORY]);
              if (res.success) {
                const investorResponse = await investorModel.fetchInvestorAccount();
                inboxModel.checkForAlerts(investorResponse.investorAccount);

                navigate(ROUTES.inbox);
              } else {
                alert('Unable to sign agreement. Please try again.');
                setProcessing(false);
              }
            }}
            isDisabled={!agreementChecked}
            mt={'36px'}>
            Accept Agreement
          </Button>
        </Flex>
      </Flex>
    </UI>
  );
};
